<template>
  <div>
    <b-form-group>
      <label for="id">
        {{ label }}
        <span v-if="isRequired" class="text-danger">*</span>
      </label>
      <b-form-input
        v-model="value.$model"
        type="text"
        :id="id"
        :placeholder="placeholder"
        :state="value.$dirty ? !value.$error : null"
        aria-describedby="phoneNumber-live-feedback"
      ></b-form-input>
      <b-form-invalid-feedback :id="id + '-live-feedback'">{{ feedback }}</b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'text-input',
  props: {
    value: {
      default: null,
      required: true,
    },
    id: {
      default: null,
      required: true,
    },
    feedback: {
      default: null,
      required: true,
    },
    placeholder: {
      default: '',
      required: false,
    },
    label: {
      default: null,
      required: true,
    },
    isRequired: {
      default: false,
      required: false,
    }
  }
}
</script>